/* Text / Call (snippets/pocket-textcall.liquid): one pill for Pocket Factory's AI assistant. It opens the chat, which
   is the assistant that answers the phone (the Worker's /v1/call/chat), on this visit's card session
   (window.PocketCall, assets/pocket-call.js): the same facts, the same card, one conversation. Call (in the chat, in
   "Call about this order" and in the home page's phone section) brings the card and the chat to the phone without any
   code; "Or have us call you" opens Call me now in the same panel. What a call, the chat or an email reply changes
   shows on the card (a short "Updated by your call" on the preview), in the chat as a note, for a moment in the
   "On a call" pill, and once to screen readers.
   The pill is one fixed layer on <body>. It never hides, fades or moves while the page scrolls: it rests above the
   fixed buy bar's resting place (the bar's own height, measured when the bar changes size, never on scroll). It steps
   aside only for a state: the keyboard open for another field, or "Call about this order" showing; on a phone it waits
   once for the homepage's website field to scroll away if it would rest on it.
   "Call about this order" is the only call pop-up: once per visit, once the card is ready to buy, never while someone
   is typing, the keyboard is open, the chat is open or a call is on. It leaves by itself after a while.
   Without the Worker the pill still opens the chat (which then says how to reach us), and every tel: link still dials. */
(() => {
  const root = document.querySelector('[data-pf-tc]');
  if (!root || root.dataset.pfTcReady) return;
  root.dataset.pfTcReady = 'true';
  // Fixed things belong to the page, not to a section that could be transformed or contained.
  if (root.parentElement !== document.body) document.body.append(root);
  const $ = selector => root.querySelector(selector);
  const html = document.documentElement;
  const launcher = $('[data-pf-tc-launcher]'), panel = $('[data-pf-tc-panel]'), log = $('[data-pf-tc-log]');
  const form = $('[data-pf-tc-form]'), input = $('[data-pf-tc-input]'), send = $('[data-pf-tc-send]'), close = $('[data-pf-tc-close]');
  const chatView = $('[data-pf-tc-chat]'), callmeView = $('[data-pf-callme]'), back = $('[data-pf-tc-back]'), scrim = $('[data-pf-tc-scrim]');
  const status = $('.pf-tc__call [data-pf-tc-status]'), oncall = $('[data-pf-tc-oncall]'), about = $('[data-pf-tc-ask]'), announcer = $('[data-pf-tc-announce]');
  // The "On a call" pill: its words are the text after its dot.
  const pill = $('[data-pf-call-pill]'), pillText = pill && [...pill.childNodes].find(node => node.nodeType === 3);
  const DISPLAY = '(888) 218-9635', ABOUT_KEY = 'pf.textcall.about', ABOUT_MS = 15000;
  const LABEL = 'Chat or call our AI assistant';
  const call = () => window.PocketCall || null;
  const capture = (name, props = {}) => { try { window.posthog?.capture(name, { flow: html.dataset.pfFlow || 'classic', ...props }); } catch (_) {} };
  /** sessionStorage, read (one argument) or written; null when storage is blocked. */
  const store = (key, value) => { try { if (value === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, value); } catch (_) {} return null; };
  const reduced = () => !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const FIELD_NAMES = { pack: 'pack', finish: 'finish', orientation: 'layout', front: 'front', base: 'card color', nameOnCard: 'name on the front', purpose: 'what a tap opens', link: 'link', website: 'website' };
  const BY = { call: 'Updated by your call', chat: 'Updated from the chat', email: 'Updated from your email' };
  /** What changed, in a few words and a natural order, for the "On a call" chip and the announcement:
   * "10 cards, Glossy, opens booksy.com/juniper-cafe". */
  const shortLink = url => String(url || '').replace(/^https?:\/\/(www\.)?/i, '').replace(/\/$/, '').slice(0, 40);
  const OPENS = { Reviews: 'your review page', Contact: 'your contact details', Booking: 'your booking page', Social: 'your social profile', Website: 'your website', Other: 'your link' };
  const FRONTS = { 'Logo Mark': 'logo on the front', Wordmark: 'name on the front', 'Logo Mark + Wordmark': 'logo and name on the front', 'Artwork Only': 'artwork on the front' };
  function summary(fields, card = {}) {
    const has = new Set(fields), words = [];
    if (has.has('pack') && card.pack) words.push(`${card.pack} ${Number(card.pack) === 1 ? 'card' : 'cards'}`);
    if (has.has('finish') && card.finish) words.push(String(card.finish));
    if (has.has('orientation') && card.orientation) words.push(`${String(card.orientation).toLowerCase()} layout`);
    if (has.has('base') && card.base) words.push(`${card.base === 'Brand Color' ? 'brand color' : String(card.base).toLowerCase()} card`);
    if (has.has('front') && card.front) words.push(FRONTS[card.front] || `front: ${card.front}`);
    if (has.has('nameOnCard') && card.nameOnCard) words.push(`“${card.nameOnCard}” on the front`);
    if (has.has('link') && card.link) words.push(`opens ${shortLink(card.link)}`);
    else if (has.has('purpose') && card.purpose) words.push(`opens ${OPENS[card.purpose] || 'your link'}`);
    if (has.has('website')) words.push(card.website ? `your website: ${shortLink(card.website)}` : 'your website');
    return words.join(', ') || fields.map(f => FIELD_NAMES[f] || f).join(', ');
  }
  /** The one polite voice for changes made from elsewhere (the open chat's log speaks for itself). */
  function announce(text) {
    if (!announcer || !text) return;
    announcer.textContent = '';
    setTimeout(() => { announcer.textContent = text; }, 60);
  }

  function bubble(kind, text) {
    const node = document.createElement('p');
    node.className = `pf-tc__msg pf-tc__msg--${kind}`;
    node.textContent = text;
    return node;
  }
  function add(kind, text) {
    const node = bubble(kind, text);
    log.insertBefore(node, thinking.isConnected ? thinking : null);
    log.scrollTop = log.scrollHeight;
    return node;
  }
  const thinking = bubble('bot', 'Typing…');
  thinking.classList.add('pf-tc__thinking');
  thinking.setAttribute('aria-label', 'The assistant is typing');
  function busy(on) {
    if (on) log.append(thinking); else thinking.remove();
    log.setAttribute('aria-busy', String(on));
    send.disabled = on;
    send.setAttribute('aria-busy', String(on));
    document.dispatchEvent(new CustomEvent('pocket:textcall', { detail: { busy: on } }));
    log.scrollTop = log.scrollHeight;
  }

  // The conversation so far (it lives on the card session, so it follows the visitor from page to page).
  let loaded = false;
  async function history() {
    if (loaded || !call()?.session?.()) return;
    loaded = true;
    try {
      const data = await call().api('/v1/call/chat');
      for (const m of data?.messages || []) add(m.from === 'you' ? 'user' : 'bot', m.text);
    } catch (_) { loaded = false; }
  }

  async function ask(text) {
    const pc = call();
    add('user', text);
    if (!pc) { add('error', `The assistant can't answer right now. Call us free at ${DISPLAY}.`); return; }
    busy(true);
    capture('pf_textcall_message', { length: text.length });
    try {
      let answer;
      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          await pc.ensureSession();
          answer = await pc.api('/v1/call/chat', { method: 'POST', timeout: 25000, body: JSON.stringify({ message: text, ...(pc.hasCard?.() ? { config: pc.snapshot(), seen: pc.seen() } : {}) }) });
          break;
        } catch (error) {
          // The session ended (a day old, or the tab was idle): one fresh session, once.
          if (error.status === 404 && attempt === 0) { pc.reset?.(); continue; }
          throw error;
        }
      }
      add('bot', answer.reply);
      const changed = answer.config ? pc.applyFromChat(answer.config, answer.rev) : (pc.applyFromChat(null, answer.rev), []);
      if (changed.length) add('note', `Updated on your card: ${changed.map(f => FIELD_NAMES[f] || f).join(', ')}.`);
      if (answer.nudge) pc.nudge();
    } catch (error) {
      add('error', error.body?.error || `The assistant can't answer right now. Call us free at ${DISPLAY}.`);
    } finally {
      busy(false);
    }
  }

  form.addEventListener('submit', event => {
    event.preventDefault();
    const text = input.value.replace(/\s+/g, ' ').trim();
    if (!text || send.disabled) return;
    input.value = '';
    fit();
    ask(text);
  });
  input.addEventListener('keydown', event => {
    if (event.key !== 'Enter' || event.shiftKey || event.isComposing) return;
    event.preventDefault();
    if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
  });
  const fit = () => { input.style.height = 'auto'; input.style.height = Math.min(input.scrollHeight + 2, 120) + 'px'; };
  input.addEventListener('input', fit);

  // Call (every tel: link marked data-pf-tc-dial): the call brings this card and conversation. A phone dials the card
  // session's link (the card links itself); a desktop shows the number where the tap was. Never a code.
  async function dial(event, node) {
    const pc = call();
    if (!pc) return;
    event.preventDefault();
    if (node.getAttribute('aria-busy') === 'true') return;
    const where = node.closest('[data-pf-phone],[data-pf-tc-ask],.pf-tc__call')?.querySelector('[data-pf-tc-status]') || status;
    // A link whose line is in the panel (the buy bar's number): on a computer the panel opens so the number shows.
    if (where === status && panel.hidden && !window.matchMedia?.('(pointer: coarse)').matches) open(node, { view: 'call' });
    if (where) where.textContent = 'Connecting…';
    node.setAttribute('aria-busy', 'true');
    try {
      const done = await pc.callAgent();
      if (where) where.textContent = done.text;
      if (!done.phone) node.setAttribute('href', done.dial);
      if (node.closest('[data-pf-tc-ask]')) { store(ABOUT_KEY, '1'); if (done.phone) hideAbout(); }
      // A phone that didn't start the call (the dialer was cancelled): the line clears after a while.
      if (done.phone && where) setTimeout(() => { if (!onCall && where.textContent === done.text) where.textContent = ''; }, 10000);
    } finally {
      node.removeAttribute('aria-busy');
    }
  }
  const placement = node => node.closest('[data-pf-phone]') ? 'phone_section' : node.closest('[data-pf-tc-ask]') ? 'call_about_order' : node.closest('[data-buy-bar]') ? 'buy_bar' : 'chat';
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-pf-tc-dial]');
    if (link && !event.defaultPrevented && event.button === 0 && !event.metaKey && !event.ctrlKey) { capture('pf_textcall_call', { placement: placement(link) }); dial(event, link); return; }
    const opener = event.target.closest?.('[data-pf-tc-open]');
    if (opener) { event.preventDefault(); open(opener); }
  });

  // Call me now: a view in the same panel (snippets/pocket-callme.liquid; the request itself is pocket-call.js).
  let callmeFrom = null;
  function showCallme(from) {
    if (!callmeView) return;
    if (panel.hidden) open(from || launcher, { view: 'callme' });
    callmeFrom = from && root.contains(from) ? from : $('[data-pf-tc-callme]');
    chatView.hidden = true;
    callmeView.hidden = false;
    back.hidden = false;
    capture('pf_textcall_callme');
    // The number field takes focus: they came here to type it (a deliberate tap, so the keyboard is expected).
    const phone = callmeView.querySelector('[data-pf-callme-phone]');
    (phone && !phone.disabled ? phone : callmeView.querySelector('h3'))?.focus({ preventScroll: true });
  }
  function showChat(focus = true) {
    if (!callmeView || callmeView.hidden) return;
    callmeView.hidden = true;
    chatView.hidden = false;
    back.hidden = true;
    if (focus) (callmeFrom?.isConnected ? callmeFrom : input).focus({ preventScroll: true });
    log.scrollTop = log.scrollHeight;
  }
  // pocket-call.js resets the form (no old error or evening offer), then shows the view.
  $('[data-pf-tc-callme]')?.addEventListener('click', event => (call()?.openCallme ? call().openCallme(event.currentTarget) : showCallme(event.currentTarget)));
  back?.addEventListener('click', () => showChat());

  // A call, the chat or an email reply changed the card: a short "Updated by your call" on the preview, a note in the
  // chat, the "On a call" pill says what changed for a moment, and screen readers hear it once.
  let pillTimer = 0, flagTimer = 0;
  const PILL_TEXT = pillText?.data || '';
  function flagPreview(source) {
    const main = document.querySelector('[data-card-main]');
    if (!main || !BY[source]) return;
    let flag = main.querySelector(':scope > .pf-tc-updated');
    if (!flag) {
      flag = document.createElement('div');
      flag.className = 'pf-tc-updated';
      flag.setAttribute('aria-hidden', 'true');
      flag.innerHTML = '<span class="pf-tc-updated__ring"></span><span class="pf-tc-updated__tag"></span>';
      main.append(flag);
    }
    flag.querySelector('.pf-tc-updated__tag').textContent = BY[source];
    flag.classList.remove('pf-tc-updated--on');
    void flag.offsetWidth;
    flag.classList.add('pf-tc-updated--on');
    clearTimeout(flagTimer);
    flagTimer = setTimeout(() => flag.classList.remove('pf-tc-updated--on'), 3600);
  }
  document.addEventListener('pocket:remote-applied', event => {
    const { fields = [], source = 'call', card } = event.detail || {};
    if (!fields.length) return;
    flagPreview(source);
    const words = summary(fields, card);
    if (source !== 'chat') add('note', `${source === 'email' ? 'From your email' : 'On the call'}: ${fields.map(f => FIELD_NAMES[f] || f).join(', ')} changed on your card.`);
    // The open chat's log already says it; otherwise this is the one announcement.
    if (panel.hidden) announce(`${BY[source] || 'Updated'}: ${words}.`);
    if (source !== 'call' || !pill || pill.hidden || !pillText) return;
    clearTimeout(pillTimer);
    pillText.data = `Updated: ${words}`;
    pill.classList.add('pf-tc--changed');
    pillTimer = setTimeout(() => { pillText.data = PILL_TEXT; pill.classList.remove('pf-tc--changed'); }, 3200);
  });
  let onCall = false;
  document.addEventListener('pocket:call-state', event => {
    const now = !!event.detail?.onCall;
    if (now === onCall) return;
    if (onCall && !now) add('note', 'The call ended. You can keep chatting here.');
    if (now) announce("You're on a call with Pocket Factory's assistant. Changes it makes show on your card.");
    onCall = now;
    if (oncall) oncall.hidden = !now;
    root.classList.toggle('pf-tc--oncall', now);
    launcher.setAttribute('aria-label', now ? `${LABEL} (on a call)` : LABEL);
    // The call is on: "Calling…" and the desktop's number line have done their job.
    if (now) { hideAbout(); for (const node of document.querySelectorAll('[data-pf-tc-status]')) node.textContent = ''; }
  });

  // Open and close. On phones (and short landscape screens) the panel is a sheet over most of the page (CSS), so there
  // it is modal: Tab stays in it, Escape and a tap above it close it, and focus goes back to what opened it.
  const sheet = window.matchMedia?.('(max-width:599px),(max-height:520px)');
  let opener = null, tapped = -Infinity;
  const modal = () => {
    const on = !panel.hidden && !!sheet?.matches;
    if (on) panel.setAttribute('aria-modal', 'true'); else panel.removeAttribute('aria-modal');
    if (scrim) scrim.hidden = !on;
  };
  function open(from, { view = 'chat' } = {}) {
    // They found the assistant: "Call about this order" has nothing left to say this visit.
    hideAbout();
    store(ABOUT_KEY, '1');
    if (!panel.hidden) { if (view === 'chat') { showChat(false); input.focus({ preventScroll: true }); } return; }
    opener = from || launcher;
    panel.hidden = false;
    root.classList.add('pf-tc--open');
    launcher.setAttribute('aria-expanded', 'true');
    modal();
    document.dispatchEvent(new CustomEvent('pocket:textcall', { detail: { open: true } }));
    capture('pf_textcall_open', { placement: from === launcher ? 'launcher' : from?.closest?.('[data-pf-phone]') ? 'phone_section' : from?.matches?.('[data-pfx-questions]') ? 'bar_questions' : from?.closest?.('[data-buy-bar]') ? 'buy_bar' : 'page' });
    history();
    if (view === 'chat') {
      showChat(false);
      // On touch screens the title takes focus, so the keyboard doesn't cover the conversation.
      (window.matchMedia?.('(pointer: coarse)').matches ? $('.pf-tc__title') : input).focus({ preventScroll: true });
    } else if (view === 'call') {
      // A call link elsewhere (the buy bar's number) opened it: focus goes to its Call, with the line under it.
      showChat(false);
      $('.pf-tc__call [data-pf-tc-dial]')?.focus({ preventScroll: true });
    }
    log.scrollTop = log.scrollHeight;
  }
  function shut() {
    if (panel.hidden) return;
    showChat(false);
    panel.hidden = true;
    root.classList.remove('pf-tc--open');
    launcher.setAttribute('aria-expanded', 'false');
    modal();
    document.dispatchEvent(new CustomEvent('pocket:textcall', { detail: { open: false } }));
    const to = opener && opener.isConnected && !opener.closest('[hidden]') ? opener : launcher;
    to.focus({ preventScroll: true });
    lift();
  }
  launcher.addEventListener('click', () => (panel.hidden ? open(launcher) : shut()));
  // "Questions?" on the buy bar asks first (pocket-cro.js: a cancelable pocket:questions): this chat answers it, and
  // focus goes back to the link when it closes.
  document.addEventListener('pocket:questions', event => {
    event.preventDefault();
    open(document.querySelector('[data-pfx-questions]') || launcher);
  });
  close.addEventListener('click', shut);
  scrim?.addEventListener('click', shut);
  sheet?.addEventListener?.('change', modal);
  root.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !panel.hidden && panel.contains(event.target)) {
      event.preventDefault();
      if (callmeView && !callmeView.hidden) showChat(); else shut();
      return;
    }
    if (event.key === 'Escape' && about && !about.hidden && about.contains(event.target)) { event.preventDefault(); dismissAbout(); return; }
    if (event.key !== 'Tab' || !panel.hasAttribute('aria-modal')) return;
    const items = [...panel.querySelectorAll('a[href],button,textarea,input,[tabindex]')].filter(node => node.tabIndex >= 0 && !node.disabled && !node.closest('[hidden]'));
    const at = document.activeElement, last = items[items.length - 1];
    if (event.shiftKey ? at === items[0] || !items.includes(at) : at === last || !panel.contains(at)) { event.preventDefault(); (event.shiftKey ? last : items[0])?.focus(); }
  });
  document.addEventListener('pointerdown', event => { if (!root.contains(event.target)) tapped = event.timeStamp; }, true);
  document.addEventListener('focusin', event => {
    if (!panel.hasAttribute('aria-modal') || root.contains(event.target) || event.target.closest?.('dialog[open]')) return;
    if (event.timeStamp - tapped < 1000) shut(); else (callmeView && !callmeView.hidden ? callmeView.querySelector('h3') : input).focus({ preventScroll: true });
  });

  // Where the pill rests: above the fixed bottom bar (the buy bar, the guides' mobile action) by the bar's own height
  // and offset, or at the bottom on a page without one (or before the homepage's bar goes live). The bar sliding out of
  // the way and back (pocket-cro.js tucks it while the hero or an order button is on screen) never moves the pill: it
  // keeps the bar's resting place. Measured when the bar changes size or goes live, and when the layout changes size,
  // never on scroll. The panel, while open on a wide screen, keeps its place until it closes.
  const DOCKS = [...document.querySelectorAll('[data-buy-bar],[data-pfa-mobile-cta]')];
  let lifted = -1;
  function restingLift() {
    for (const node of DOCKS) {
      const style = getComputedStyle(node);
      if (style.position !== 'fixed' || style.display === 'none' || !node.offsetHeight) continue;
      if (node.matches('[data-buy-bar]') && html.dataset.pfFlow === 'reviews-v2' && !html.classList.contains('pfx-bar-live')) continue;
      // Its offset from the bottom (a floating bar keeps a margin), from its own style: the browser's toolbar never counts.
      const below = Number.parseFloat(style.bottom);
      return node.offsetHeight + (Number.isFinite(below) && below > 0 ? below : 0);
    }
    return 0;
  }
  function lift() {
    if (!panel.hidden && !sheet?.matches) return;
    const next = Math.round(restingLift());
    if (next === lifted) return;
    lifted = next;
    root.style.setProperty('--pf-tc-lift', `${next}px`);
    root.classList.toggle('pf-tc--lifted', next > 0);
  }
  // Its whole box: the offer strip's room is padding, so the content box alone can stay the same while the bar shrinks.
  if (window.ResizeObserver) { const watch = new ResizeObserver(() => lift()); DOCKS.forEach(node => watch.observe(node, { box: 'border-box' })); }
  // The homepage's bar goes live with a class on <html> (pocket-cro.js); its tuck classes change nothing here.
  if (window.MutationObserver) {
    let live = html.classList.contains('pfx-bar-live');
    new MutationObserver(() => { const now = html.classList.contains('pfx-bar-live'); if (now !== live) { live = now; lift(); } }).observe(html, { attributes: true, attributeFilter: ['class'] });
  }
  window.matchMedia?.('(max-width:989px)').addEventListener?.('change', () => lift());
  window.addEventListener('orientationchange', () => setTimeout(lift, 250));
  lift();

  // The first screen stays clear: if the pill would rest on something to tap or read there (a control, a heading, a
  // price, the homepage's website field, what is marked data-pf-help-avoid such as the purpose tabs) once the bar is up
  // (the bar's own height, before it goes live), it waits until those have scrolled away, then fades in once and stays
  // (never a toggle). Checked once, on load. Layout boxes only (offsetTop: no transform, no transition in between).
  const FIRST_SCREEN = 'main :is(a[href],button,summary,input:not([type=hidden]),select,textarea,label,[role=button],h1,h2,h3,.pfx-pack,.pfx-pack-total,[data-pfx-summary-total]),[data-rv-url-form],[data-pf-help-avoid]';
  function restingBox() {
    const dock = DOCKS.find(node => getComputedStyle(node).position === 'fixed' && node.offsetHeight);
    const below = dock ? Number.parseFloat(getComputedStyle(dock).bottom) : 0;
    const potential = Math.max(lifted, dock ? dock.offsetHeight + (below > 0 ? below : 0) : 0);
    const base = Number.parseFloat(getComputedStyle(launcher).bottom) || 0, gap = Number.parseFloat(getComputedStyle(root).getPropertyValue('--pf-tc-gap')) || 12;
    const top = launcher.offsetTop - (potential > 0 ? potential + gap - base : 0);
    return { left: launcher.offsetLeft, right: launcher.offsetLeft + launcher.offsetWidth, top, bottom: top + launcher.offsetHeight };
  }
  function placeFirst() {
    if (!launcher.hidden) return;
    lift();
    // Laid out unseen for the measure (a hidden button has no box), all before the next paint.
    root.classList.add('pf-tc--measuring');
    launcher.hidden = false;
    const box = restingBox();
    const firstScreen = [...document.querySelectorAll(FIRST_SCREEN)].filter(node => {
      if (DOCKS.some(dock => dock.contains(node)) || !node.getClientRects().length || node.closest('[hidden]') || getComputedStyle(node).visibility === 'hidden') return false;
      const b = node.getBoundingClientRect();
      return b.width >= 4 && b.height >= 4 && b.bottom > 0 && b.top < window.innerHeight && box.left < b.right && box.right > b.left && box.top < b.bottom + 8 && box.bottom > b.top - 8;
    });
    if (firstScreen.length && window.IntersectionObserver) {
      root.classList.add('pf-tc--waiting');
      const showing = new Set(firstScreen);
      const reveal = () => { spy.disconnect(); root.classList.remove('pf-tc--waiting'); };
      const spy = new IntersectionObserver(entries => {
        for (const item of entries) if (!item.isIntersecting) showing.delete(item.target); else showing.add(item.target);
        if (!showing.size) reveal();
      });
      firstScreen.forEach(node => spy.observe(node));
      launcher.addEventListener('focus', reveal, { once: true });
      document.addEventListener('pocket:textcall', reveal, { once: true });
    }
    root.classList.remove('pf-tc--measuring');
  }
  // The page settles first (its images and fonts move things), so the pill appears once, where it stays.
  if (document.readyState === 'complete') placeFirst();
  else {
    const frame = window.requestAnimationFrame?.bind(window) || (fn => setTimeout(fn, 16));
    const settle = () => (document.fonts?.ready || Promise.resolve()).then(() => frame(placeFirst));
    window.addEventListener('load', settle, { once: true });
    setTimeout(placeFirst, 2500);
  }

  // Step 2 (Bryton's iPhone, Oct 23): while a card's step 2 is on screen or holds the focus (the home page's question 2:
  // its tiles, its link field and "Watch a tap"; in the order box, step 02's tiles and link field once "Change
  // destination" opens them) the pill steps out of the way, and it comes back once step 2 has left the screen. Only
  // where it would sit over step 2 (on a wide screen it rests beside it). An IntersectionObserver says when step 2 comes
  // and goes, never a scroll listener, and the pill fades: passing step 2 is one fade out and one fade in, with a short
  // wait before it comes back so an edge can't blink.
  const STEP_TWO = '[data-pfq-q2],[data-rv-destination-options]';
  const stepTwo = new Set();
  let stepFocus = false, stepTimer = 0;
  const besidePill = node => {
    const a = node.getBoundingClientRect(), b = launcher.getBoundingClientRect();
    return !b.width || (a.left < b.right && a.right > b.left);
  };
  function stepAside() {
    clearTimeout(stepTimer);
    if (stepFocus || coveredNow() || [...stepTwo].some(node => node.isConnected && besidePill(node))) root.classList.add('pf-tc--aside');
    else if (root.classList.contains('pf-tc--aside')) stepTimer = setTimeout(() => root.classList.remove('pf-tc--aside'), 300);
  }

  // Nothing to tap in what is marked data-pf-help-avoid (the card's questions: question 1's chips and open choice,
  // question 2's tiles; the cart's lines and checkout; the purpose tabs) is ever under the pill or "Call about this
  // order" (Oct 23: with the designer's chips, it sat on question 1 on phones). Those controls are watched by an
  // IntersectionObserver cut down to the band of the screen the pill rests in (and the pop-up, while it shows): the pill
  // steps aside only while one is really beneath it, and comes back as it scrolls on. The band is measured again when
  // the pill moves (the bar's height, the pop-up) or the screen changes size.
  const AVOID_CONTROL = '[data-pf-help-avoid] :is(a[href],button,input:not([type=hidden]),select,textarea,label,summary,[role=button],[role=radio],[role=tab],[tabindex]:not([tabindex="-1"]))';
  const covered = new Set();
  let bandSpy = null, bandKey = '', bandTimer = 0;
  // The pill and, while it shows, the pop-up (as wide as a phone's screen), with 8 px around them.
  function floatingBox() {
    if (launcher.hidden) return null;
    const pill = launcher.getBoundingClientRect();
    const ask = about && !about.hidden ? about.getBoundingClientRect() : null;
    const boxes = [pill, ask].filter(b => b && b.width > 0 && b.height > 0);
    if (!boxes.length) return null;
    return {
      left: Math.min(...boxes.map(b => b.left)) - 8,
      right: Math.max(...boxes.map(b => b.right)) + 8,
      top: Math.min(...boxes.map(b => b.top)) - 8,
      bottom: Math.max(...boxes.map(b => b.bottom)) + 8,
    };
  }
  function coveredNow() {
    if (!covered.size) return false;
    const box = floatingBox();
    return !!box && [...covered].some(node => {
      if (!node.isConnected || !node.getClientRects().length) return false;
      const b = node.getBoundingClientRect();
      return b.width > 0 && b.left < box.right && b.right > box.left;
    });
  }
  function watchBand() {
    const box = floatingBox(), height = window.innerHeight;
    const top = box ? Math.max(0, Math.floor(box.top)) : 0, bottom = box ? Math.min(height, Math.ceil(box.bottom)) : 0;
    const key = box && bottom > top ? `${top}:${bottom}:${height}` : '';
    if (key === bandKey) return;
    bandKey = key;
    bandSpy?.disconnect();
    bandSpy = null;
    covered.clear();
    if (key && window.IntersectionObserver) {
      bandSpy = new IntersectionObserver(entries => {
        for (const item of entries) item.isIntersecting ? covered.add(item.target) : covered.delete(item.target);
        stepAside();
      }, { rootMargin: `${-top}px 0px ${-(height - bottom)}px 0px` });
      document.querySelectorAll(AVOID_CONTROL).forEach(node => bandSpy.observe(node));
    }
    stepAside();
  }
  // Measured after a move settles (the pill's lift is a 0.25 s transform), never on scroll.
  const watchBandSoon = () => { clearTimeout(bandTimer); bandTimer = setTimeout(watchBand, 300); };
  window.addEventListener('resize', watchBandSoon);
  if (window.MutationObserver) {
    // The pill moves (the bar's height, the pop-up showing) by the classes and the lift on the Text / Call root.
    new MutationObserver(watchBandSoon).observe(root, { attributes: true, attributeFilter: ['class', 'style'] });
    // Controls a page adds later (a /cart line's new −, + and Remove after a change) are watched as they come.
    new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (!bandSpy || node.nodeType !== 1) return;
      if (node.matches(AVOID_CONTROL)) bandSpy.observe(node);
      node.querySelectorAll(AVOID_CONTROL).forEach(each => bandSpy.observe(each));
    }))).observe(document.body, { childList: true, subtree: true });
  }
  watchBandSoon();
  if (window.IntersectionObserver) {
    const spy = new IntersectionObserver(entries => {
      for (const item of entries) item.isIntersecting ? stepTwo.add(item.target) : stepTwo.delete(item.target);
      stepAside();
    });
    // A hidden step 2 (the questions before there is a card) is never on screen; the observer sees it when it shows.
    document.querySelectorAll(STEP_TWO).forEach(node => spy.observe(node));
  }
  document.addEventListener('focusin', event => { stepFocus = !!event.target.closest?.(STEP_TWO); stepAside(); });
  document.addEventListener('focusout', event => { if (!event.relatedTarget?.closest?.(STEP_TWO)) { stepFocus = false; stepAside(); } });

  // "Call about this order": once per visit, once the card is ready to buy (the bar is ready and holds nothing), and
  // only while nothing else is going on: no field focused, the keyboard closed, no typing in the last 8 s, the chat
  // closed, no call on, no dialog up, step 2 off the screen (it would sit over it, like the pill). If now isn't the
  // moment it waits; once seen or dismissed it doesn't come back.
  // It rests above the bar like the pill (which steps aside meanwhile) and leaves by itself after 15 s untouched.
  const bar = document.querySelector('[data-buy-bar]');
  let lastInput = 0, aboutTimer = 0, leaveTimer = 0, shown = false;
  document.addEventListener('input', () => { lastInput = Date.now(); }, true);
  document.addEventListener('change', () => { lastInput = Date.now(); }, true);
  const keyboardOpen = () => html.classList.contains('pf-keyboard-open') || (window.visualViewport && window.innerHeight - window.visualViewport.height > 120);
  const ready = () => !!bar && bar.dataset.state === 'ready' && !bar.dataset.hold && !bar.querySelector('[data-pf-buy-now]')?.hidden;
  // Where the pop-up would rest, measured unseen and without its rise (which starts 12 px lower), all before the next
  // paint, and whether a control would be under it.
  function askBox() {
    if (!about) return null;
    if (!about.hidden) return about.getBoundingClientRect();
    about.style.visibility = 'hidden';
    about.style.animation = 'none';
    about.hidden = false;
    const box = about.getBoundingClientRect();
    about.hidden = true;
    about.style.visibility = about.style.animation = '';
    return box;
  }
  function controlUnder(box) {
    if (!box || !(box.height > 0)) return false;
    return [...document.querySelectorAll(AVOID_CONTROL)].some(node => {
      if (!node.getClientRects().length) return false;
      const b = node.getBoundingClientRect();
      return b.width > 0 && b.height > 0 && b.top < box.bottom + 8 && b.bottom > box.top - 8 && b.left < box.right + 8 && b.right > box.left - 8;
    });
  }
  function aboutAllowed() {
    if (!about || shown || store(ABOUT_KEY) || window.Shopify?.designMode || !ready()) return false;
    if (document.visibilityState === 'hidden' || !panel.hidden || onCall || root.classList.contains('pf-tc--aside')) return false;
    if (controlUnder(askBox())) return false;
    const active = document.activeElement;
    if (active && active !== document.body && (active.matches?.('input,textarea,select,[contenteditable="true"]') || root.contains(active))) return false;
    if (keyboardOpen() || Date.now() - lastInput < 8000) return false;
    return ![...document.querySelectorAll('dialog[open],[aria-modal="true"]')].some(node => node.getClientRects().length);
  }
  function leaveSoon() {
    clearTimeout(leaveTimer);
    leaveTimer = setTimeout(() => { if (about && !about.hidden && !about.matches(':hover') && !about.contains(document.activeElement)) hideAbout(); else leaveSoon(); }, ABOUT_MS);
  }
  function showAbout() {
    clearTimeout(aboutTimer);
    if (!about || shown || store(ABOUT_KEY)) return;
    if (!aboutAllowed()) { if (ready()) aboutTimer = setTimeout(showAbout, 3000); return; }
    shown = true;
    store(ABOUT_KEY, '1');
    about.classList.remove('pf-tc--leaving');
    about.hidden = false;
    root.classList.add('pf-tc--asking');
    capture('pf_textcall_about_shown');
    leaveSoon();
  }
  function hideAbout() {
    clearTimeout(aboutTimer); clearTimeout(leaveTimer);
    if (!about || about.hidden) { root.classList.remove('pf-tc--asking'); return; }
    const hadFocus = about.contains(document.activeElement);
    const done = () => { about.hidden = true; about.classList.remove('pf-tc--leaving'); root.classList.remove('pf-tc--asking'); };
    if (reduced()) done(); else { about.classList.add('pf-tc--leaving'); setTimeout(done, 180); }
    if (hadFocus) launcher.focus({ preventScroll: true });
  }
  function dismissAbout() { capture('pf_textcall_about_dismiss'); hideAbout(); }
  $('[data-pf-tc-ask-close]')?.addEventListener('click', dismissAbout);
  if (about && bar && !store(ABOUT_KEY)) {
    const arm = () => { if (!shown && ready()) { clearTimeout(aboutTimer); aboutTimer = setTimeout(showAbout, 4000); } };
    if (window.MutationObserver) new MutationObserver(arm).observe(bar, { attributes: true, attributeFilter: ['data-state', 'data-hold'] });
    arm();
  }
  // A field takes focus while it shows (the keyboard is coming): it steps away for the visit.
  document.addEventListener('focusin', event => { if (about && !about.hidden && !root.contains(event.target) && event.target.matches?.('input,textarea,select,[contenteditable="true"]')) hideAbout(); });

  // ?callme=1 on any page: the chat opens on Call me now (a link for DMs and emails).
  if (/^(1|true|yes)$/i.test(new URLSearchParams(location.search).get('callme') || '')) showCallme(null);

  window.PocketTextCall = { open, close: shut, ask, callme: showCallme, chat: () => showChat(), about: showAbout };
})();
